export default __webpack_public_path__ + "static/media/btn_delguer_droits_disable.7151cdbc.svg";